import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";
import { QueryProvider } from "@/components/providers/query-provider";
import { LoadingIndicator } from "@/components/shared/loading-indicator";
import { CommonAlertDialog } from "@/components/shared/common-alert-dialog";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

// 인증된 사용자가 접근하면 안 되는 경로 (로그인/회원가입)
const authPaths = [
  "/auth/login",
  "/auth/signup/required-term",
  "/auth/signup/signup-form",
  "/auth/signup/personal-sms-verification",
  "/auth/signup/under-14-sms-verification",
  "/auth/signup/parent-kmc-verification",
];

// 인증이 필요한 보호된 경로
const protectedPaths = ["/main", "/pending-approval"];

// 인증 토큰(teacherAccessToken)은 HttpOnly 쿠키라 JS에서 읽을 수 없다.
// 클라이언트 가드는 로그인 시 저장되는 localStorage 유저 존재 여부로 판단하고,
// 실제 만료/무효 토큰은 API 401 인터셉터가 localStorage를 비우고 로그인으로 보낸다.
function isAuthenticated(): boolean {
  try {
    return !!localStorage.getItem("growing-teacher-user");
  } catch {
    return false;
  }
}

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const authed = isAuthenticated();

    // 1. 인증된 사용자가 로그인/회원가입 페이지 접근 시
    if (authed && authPaths.includes(location.pathname)) {
      throw redirect({ to: "/main" });
    }

    // 2. 인증되지 않은 사용자가 보호된 경로 접근 시
    if (!authed && protectedPaths.includes(location.pathname)) {
      throw redirect({ to: "/auth/login" });
    }

    // 3. isApproved 체크는 각 페이지에서 API를 통해 최신 정보로 확인
    // (JWT의 isApproved는 발급 시점의 스냅샷이므로 신뢰할 수 없음)
  },
  component: RootComponent,
});

function RootComponent() {
  return (
    <QueryProvider>
      <TooltipProvider>
        <Outlet />
      </TooltipProvider>
      <LoadingIndicator />
      <Toaster richColors />
      <CommonAlertDialog />
    </QueryProvider>
  );
}
